import type { ReactNode } from 'react';
import React from 'react';

import { Modal as AntModal, Button, Grid, Tooltip } from 'antd';

const { useBreakpoint } = Grid;

interface ModalProps {
  open: boolean;
  keepMounted?: boolean;
  size?: false | 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  textTitle: string;
  textReturnButton: string;
  textProceedButton?: string | JSX.Element;
  hideReturnButton?: boolean;
  hideProceedButton?: boolean;
  isProceedButtonDisabled?: boolean;
  enableScroll?: boolean;
  children: ReactNode;
  setClose: () => void;
  handleProceedClick?: (any: any) => void;
  handleReturnClick?: (any: any) => void;
  textTooltipProceedButton?: string;
  isProceedButtonLoading?: boolean;
}

const sizeToWidth: Record<string, number> = {
  xs: 400,
  sm: 600,
  md: 900,
  lg: 1200,
  xl: 1536
};

function Modal({
  open,
  keepMounted = false,
  size = 'sm',
  textTitle,
  textReturnButton,
  textProceedButton,
  children,
  textTooltipProceedButton,
  isProceedButtonDisabled = false,
  isProceedButtonLoading = false,
  hideReturnButton = false,
  hideProceedButton = false,
  enableScroll = false,
  setClose,
  handleProceedClick,
  handleReturnClick = setClose
}: ModalProps) {
  const screens = useBreakpoint();
  const isMobile = !screens.sm;

  const modalWidth = size ? sizeToWidth[size] || 600 : 600;

  const proceedButton = (
    <Button
      type='primary'
      id='modal-proceed-button'
      onClick={handleProceedClick}
      className='max-sm:w-full'
      disabled={isProceedButtonDisabled}
      loading={isProceedButtonLoading}
    >
      {textProceedButton}
    </Button>
  );

  return (
    <AntModal
      open={open}
      onCancel={setClose}
      destroyOnHidden={!keepMounted}
      width={isMobile ? '100%' : modalWidth}
      classNames={{ body: enableScroll || isMobile ? 'overflow-y-auto' : 'overflow-y-visible' }}
      title={textTitle}
      closable
      footer={
        <div className='flex flex-wrap items-center justify-end gap-2 max-sm:flex-col'>
          {!hideReturnButton && (
            <Button type='text' id='modal-return-button' onClick={handleReturnClick} className='max-sm:w-full'>
              {textReturnButton}
            </Button>
          )}
          {!hideProceedButton &&
            (textTooltipProceedButton ? (
              <Tooltip title={textTooltipProceedButton} placement='top'>
                {proceedButton}
              </Tooltip>
            ) : (
              proceedButton
            ))}
        </div>
      }
    >
      {children}
    </AntModal>
  );
}

export default Modal;
